<template>
  <div class="columns -spacing-static-d is-tablet">
    <div class="column is-5-desktop">
      <div class="quote-header">
        <legend>{{ name }}</legend>
      </div>
      <div class="-spacing-static-e">
        <label
          :for="coverageStepIndex === 0 ? 'bodilyInjury' : 'bodilyInjuryValue'"
          :class="{
            error: errors.has('bodilyInjury')
          }"
          >Bodily Injury (Per Person/Per Incident)</label
        >
        <div class="select-wrapper" v-show="coverageStepIndex === 0">
          <v-select
            placeholder="Select Coverage"
            v-model="form.bodilyInjury"
            :searchable="false"
            :options="selectsCoverage[selectedState].bodilyInjury"
            id="bodilyInjury"
            v-on:input="sendUpdate('bodilyInjury')"
            :v-validate="'required'"
            name="bodilyInjury"
            :class="{
              error: errors.has('bodilyInjury'),
              dropdown_toggle_disabled_bg: true
            }"
          ></v-select>
        </div>
        <div class="input" v-show="coverageStepIndex !== 0">
          <input
            class="input__field"
            name="bodilyInjury"
            id="bodilyInjuryValue"
            type="text"
            v-model="form.bodilyInjury"
            disabled
          />
        </div>
      </div>
      <!-- UMBI -->
      <div class="-spacing-static-e">
        <label
          :for="
            coverageStepIndex === 0
              ? 'uninsuredBodilyInjury'
              : 'uninsuredBodilyInjuryValue'
          "
          :class="{
            error: errors.has('uninsuredBodilyInjury')
          }"
          >Uninsured Motorist Coverage</label
        >
        <div class="select-wrapper" v-show="coverageStepIndex === 0">
          <v-select
            v-model="form.uninsuredBodilyInjury"
            placeholder="Select Coverage"
            :searchable="false"
            :options="uninsuredBodilyInjuryOptions"
            id="uninsuredBodilyInjury"
            v-on:input="sendUpdate('uninsuredBodilyInjury')"
            :v-validate="'required'"
            name="uninsuredBodilyInjury"
            :class="{
              error: errors.has('uninsuredBodilyInjury'),
              dropdown_toggle_disabled_bg: true
            }"
          ></v-select>
        </div>
        <div class="input" v-show="coverageStepIndex !== 0">
          <input
            class="input__field"
            name="uninsuredBodilyInjury"
            id="uninsuredBodilyInjuryValue"
            type="text"
            v-model="form.uninsuredBodilyInjury"
            disabled
          />
        </div>
      </div>
      <!-- UIM -->
      <div class="-spacing-static-e">
        <label
          :for="
            coverageStepIndex === 0
              ? 'underinsuredMotorist'
              : 'underinsuredMotoristValue'
          "
          :class="{
            error: errors.has('underinsuredMotorist')
          }"
          >Underinsured Motorist Coverage</label
        >
        <div class="select-wrapper" v-show="coverageStepIndex === 0">
          <v-select
            v-model="form.underinsuredMotorist"
            placeholder="Select Coverage"
            :searchable="false"
            :options="underinsuredMotoristOptions"
            id="underinsuredMotorist"
            v-on:input="sendUpdate('underinsuredMotorist')"
            :v-validate="'required'"
            name="underinsuredMotorist"
            :class="{
              error: errors.has('underinsuredMotorist'),
              dropdown_toggle_disabled_bg: true
            }"
          ></v-select>
        </div>
        <div class="input" v-show="coverageStepIndex !== 0">
          <input
            class="input__field"
            name="underinsuredMotorist"
            id="underinsuredMotoristValue"
            type="text"
            v-model="form.underinsuredMotorist"
            disabled
          />
        </div>
      </div>
      <!-- UM -->
      <div class="-spacing-static-e">
        <label
          :for="
            coverageStepIndex === 0
              ? 'uninsuredMotoristStacking'
              : 'uninsuredMotoristStackingValue'
          "
          :class="{
            error: errors.has('uninsuredCoverageType')
          }"
          >Uninsured/Underinsured Motorist Stacking</label
        >
        <div
          class="select-wrapper"
          v-show="
            coverageStepIndex === 0 &&
              form.uninsuredBodilyInjury !== 'I decline this coverage'
          "
        >
          <v-select
            v-model="form.uninsuredCoverageType"
            placeholder="Select Coverage"
            :searchable="false"
            :options="uninsuredMotoristStackingOptions"
            id="uninsuredMotoristStacking"
            v-on:input="sendUpdate('uninsuredCoverageType')"
            :v-validate="'required'"
            name="uninsuredMotoristStacking"
            :class="{
              error: errors.has('uninsuredCoverageType'),
              dropdown_toggle_disabled_bg: true
            }"
          ></v-select>
        </div>
        <div
          class="input"
          v-show="
            coverageStepIndex !== 0 &&
              form.uninsuredBodilyInjury !== 'I decline this coverage'
          "
        >
          <input
            class="input__field"
            name="uninsuredMotoristStacking"
            id="uninsuredMotoristStackingValue"
            type="text"
            v-model="form.uninsuredMotoristStacking"
            disabled
          />
        </div>
        <div
          class="input"
          v-show="form.uninsuredBodilyInjury === 'I decline this coverage'"
        >
          <input
            class="input__field"
            name="uninsuredMotoristStacking"
            id="uninsuredMotoristStackingDecline"
            type="text"
            value="Uninsured Coverage Declined"
            disabled
          />
        </div>
      </div>
      <!--TORT-->
      <div class="-spacing-static-e">
        <label
          :for="coverageStepIndex === 0 ? 'tortOption' : 'tortOptionValue'"
          :class="{
            error: errors.has('tortOption')
          }"
          >Tort Option</label
        >
        <i class="icon icon--info tool-tip">
          <div class="content">
            <p
              v-html="
                `<strong>Limited</strong> Tort allows you and other household members covered under this policy to seek recovery for medical bills and lost wages, but not for pain and suffering or other non-monetary damages unless the injuries suffered fall within the definition of serious injury. For purposes of this coverage, serious injury includes death, serious impairment of a bodily function, or permanent serious disfigurement.<br/>
          <strong>Full</strong> Tort allows you to maintain an unrestricted right to seek financial compensation for injuries caused by other drivers - this includes medical bills, pain and suffering, and lost wages.<br/>
          Full details for each coverage will be in your policy.`
              "
            ></p>
            <i></i>
          </div>
        </i>
        <div class="select-wrapper" v-show="coverageStepIndex === 0">
          <v-select
            v-model="form.tortOption"
            placeholder="Select Coverage"
            :searchable="false"
            :options="selectsCoverage[selectedState].tortOptions"
            id="tortOption"
            v-on:input="sendUpdate('tortOption')"
            :v-validate="'required'"
            name="tortOption"
            :class="{
              error: errors.has('tortOption'),
              dropdown_toggle_disabled_bg: true
            }"
          ></v-select>
        </div>
        <div class="input" v-show="coverageStepIndex !== 0">
          <input
            class="input__field"
            name="tortOption"
            id="tortOptionValue"
            type="text"
            v-model="form.tortOption"
            disabled
          />
        </div>
      </div>

      <div class="-spacing-static-c">
        <label
          for="comprehensiveDeductible"
          :class="{
            error: errors.has('comprehensiveDeductible')
          }"
          >Comprehensive Deductible</label
        >
        <div class="select-wrapper">
          <v-select
            placeholder="Select Coverage"
            v-model="form.comprehensiveDeductible[coverageStepIndex]"
            :searchable="false"
            :options="compSelects"
            id="comprehensiveDeductible"
            v-on:input="sendUpdate('comprehensiveDeductible')"
            :v-validate="'required'"
            name="comprehensiveDeductible"
            :class="{
              error: errors.has('comprehensiveDeductible')
            }"
          ></v-select>
        </div>
      </div>

      <div class="-spacing-static-c">
        <label
          for="collisionDeductible"
          :class="{
            error: errors.has('collisionDeductible')
          }"
          >Collision Deductible</label
        >
        <div class="select-wrapper">
          <v-select
            placeholder="Select Coverage"
            v-model="form.collisionDeductible[coverageStepIndex]"
            :searchable="false"
            :options="collSelects"
            id="collisionDeductible"
            v-on:input="sendUpdate('collisionDeductible')"
            :v-validate="'required'"
            name="collisionDeductible"
            :class="{
              error: errors.has('collisionDeductible')
            }"
          ></v-select>
        </div>
      </div>

      <div class="-spacing-static-c">
        <label
          for="personalInjuryProtection"
          :class="{
            error: errors.has('personalInjuryProtection')
          }"
          >Medical Payments Coverage</label
        >
        <div class="select-wrapper">
          <v-select
            placeholder="Select Coverage"
            v-model="form.personalInjuryProtection"
            :searchable="false"
            :options="selectsCoverage[selectedState].personalInjuryProtection"
            id="personalInjuryProtection"
            v-on:input="sendUpdate('personalInjuryProtection')"
            :v-validate="'required'"
            name="personalInjuryProtection"
            :class="{
              error: errors.has('personalInjuryProtection')
            }"
          ></v-select>
        </div>
      </div>

      <div class="-spacing-static-c">
        <label
          for="rentalReimbursement"
          :class="{
            error: errors.has('rentalReimbursement')
          }"
          >Rental Reimbursement Limit</label
        >
        <div class="select-wrapper">
          <v-select
            placeholder="Select Coverage"
            v-model="form.rentalReimbursement[coverageStepIndex]"
            :searchable="false"
            :options="selectsCoverage[selectedState].rentalReimbursement"
            id="rentalReimbursement"
            v-on:input="sendUpdate('rentalReimbursement')"
            :v-validate="'required'"
            name="rentalReimbursement"
            :class="{
              error: errors.has('rentalReimbursement')
            }"
          ></v-select>
        </div>
      </div>
      <!--FPB-->
      <div class="-spacing-static-c">
        <label
          for="combinedFirstParty"
          :class="{
            error: errors.has('combinedFirstParty')
          }"
          >Combined First Party Benefits</label
        >
        <i class="icon icon--info tool-tip">
          <div class="content">
            <p
              v-html="
                `Combines coverage for <strong>Medical Payments, Income Loss, Accidental Death, and Funeral Benefits</strong> into one package. This coverage provides up to at least $177,500 of aggregate benefits or benefits payable up to three years from the date of the accident, whichever occurs first, subject to limits of up to $25,000 for Accidental Death and up to $2,500 for Funeral Benefits.`
              "
            ></p>
            <i></i>
          </div>
        </i>
        <div class="select-wrapper">
          <v-select
            v-model="form.combinedFirstParty"
            placeholder="Select Coverage"
            :searchable="false"
            :options="selectsCoverage[selectedState].combinedFirstParty"
            id="combinedFirstParty"
            v-on:input="sendUpdate('combinedFirstParty')"
            :v-validate="'required'"
            name="combinedFirstParty"
            :class="{
              error: errors.has('combinedFirstParty')
            }"
          ></v-select>
        </div>
      </div>
      <!--ADND-->
      <div class="-spacing-static-c">
        <label
          :for="
            !form.combinedFirstParty ||
            form.combinedFirstParty === 'I decline this coverage'
              ? 'accidentalDeath'
              : 'accidentalDeathValue'
          "
          :class="{
            error: errors.has('accidentalDeath')
          }"
          >Accidental Death</label
        >
        <i class="icon icon--info tool-tip">
          <div class="content">
            <p
              v-html="
                `Pays benefits to your family or designated representative, in the amount of the coverage limit you select, in the event of death from a motor vehicle related injury within 24 months of the injury.`
              "
            ></p>
            <i></i>
          </div>
        </i>
        <div
          v-if="
            !form.combinedFirstParty ||
              form.combinedFirstParty === 'I decline this coverage'
          "
          class="select-wrapper"
        >
          <v-select
            v-model="form.accidentalDeath"
            placeholder="Select Coverage"
            :searchable="false"
            :options="selectsCoverage[selectedState].accidentalDeath"
            id="accidentalDeath"
            v-on:input="sendUpdate('accidentalDeath')"
            :v-validate="'required'"
            name="accidentalDeath"
            :class="{
              error: errors.has('accidentalDeath')
            }"
          ></v-select>
        </div>
        <input
          v-else
          class="input__field"
          name="accidentalDeath"
          id="accidentalDeathValue"
          type="text"
          value="Combined Benefits Selected"
          disabled
        />
      </div>
      <!--FNRL-->
      <div class="-spacing-static-c">
        <label
          :for="
            !form.combinedFirstParty ||
            form.combinedFirstParty === 'I decline this coverage'
              ? 'funeralBenefits'
              : 'funeralBenefitsValue'
          "
          :class="{
            error: errors.has('funeralBenefits')
          }"
          >Funeral Benefits</label
        >
        <i class="icon icon--info tool-tip">
          <div class="content">
            <p
              v-html="
                `Pays benefits to your family or designated representative for reasonable and necessary expenses related to funeral, burial, or cremation, in the event of death resulting from an auto accident within 24 hours of the accident.`
              "
            ></p>
            <i></i>
          </div>
        </i>
        <div
          v-if="
            !form.combinedFirstParty ||
              form.combinedFirstParty === 'I decline this coverage'
          "
          class="select-wrapper"
        >
          <v-select
            v-model="form.funeralBenefits"
            placeholder="Select Coverage"
            :searchable="false"
            :options="selectsCoverage[selectedState].funeralBenefits"
            id="funeralBenefits"
            v-on:input="sendUpdate('funeralBenefits')"
            :v-validate="'required'"
            name="funeralBenefits"
            :class="{
              error: errors.has('funeralBenefits')
            }"
          ></v-select>
        </div>
        <input
          v-else
          class="input__field"
          name="funeralBenefits"
          id="funeralBenefitsValue"
          type="text"
          value="Combined Benefits Selected"
          disabled
        />
      </div>
      <!--INCLOSS-->
      <div class="-spacing-static-c">
        <label
          :for="
            !form.combinedFirstParty ||
            form.combinedFirstParty === 'I decline this coverage'
              ? 'incomeLoss'
              : 'incomeLossValue'
          "
          :class="{
            error: errors.has('incomeLoss')
          }"
          >Income Loss</label
        >
        <i class="icon icon--info tool-tip">
          <div class="content">
            <p
              v-html="
                `Covers you for lost income resulting from a motor vehicle accident injury, up to 80% of your lost gross income, not to exceed your selected coverage limits. Also pays individuals to perform services you are otherwise not able to perform as a result of the accident.`
              "
            ></p>
            <i></i>
          </div>
        </i>
        <div
          v-if="
            !form.combinedFirstParty ||
              form.combinedFirstParty === 'I decline this coverage'
          "
          class="select-wrapper"
        >
          <v-select
            v-model="form.incomeLoss"
            placeholder="Select Coverage"
            :searchable="false"
            :options="selectsCoverage[selectedState].incomeLoss"
            id="incomeLoss"
            v-on:input="sendUpdate('incomeLoss')"
            :v-validate="'required'"
            name="incomeLoss"
            :class="{
              error: errors.has('incomeLoss')
            }"
          ></v-select>
        </div>
        <input
          v-else
          class="input__field"
          name="incomeLoss"
          id="incomeLossValue"
          type="text"
          value="Combined Benefits Selected"
          disabled
        />
      </div>
      <!--MEDEX-->
      <div class="-spacing-static-c">
        <label
          for="extraBenefits"
          :class="{
            error: errors.has('extraBenefits')
          }"
          >Extraordinary Benefits</label
        >
        <i class="icon icon--info tool-tip">
          <div class="content">
            <p
              v-html="
                `Provides up to $1 million in coverage to pay for reasonable and necessary medical treatment and rehabilitative services exceeding $100,000, if you are involved in a motor vehicle accident.`
              "
            ></p>
            <i></i>
          </div>
        </i>
        <div class="select-wrapper">
          <v-select
            v-model="form.extraBenefits"
            placeholder="Select Coverage"
            :searchable="false"
            :options="selectsCoverage[selectedState].extraBenefits"
            id="extraBenefits"
            v-on:input="sendUpdate('extraBenefits')"
            :v-validate="'required'"
            name="extraBenefits"
            :class="{
              error: errors.has('extraBenefits')
            }"
          ></v-select>
        </div>
      </div>

      <div class="has-placeholders effective-date-field">
        <div class="limit-container" v-if="coverageStepIndex === 0">
          <label class="input -spacing-static-c">
            <masked-input
              :class="{
                input__field: true,
                error: errors.has('policyEffectiveDate')
              }"
              type="text"
              name="policyEffectiveDate"
              placeholder="Policy Effective Date"
              :keepCharPositions="true"
              v-model="form.policyEffectiveDate"
              :v-validate="'required|effectiveDateValidator|isLeapYear'"
              :guide="true"
              :placeholderChar="'_'"
              :pipe="autoCorrectedDatePipe"
              :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
              @blur="
                dateInputChanged(
                  $event,
                  'policyEffectiveDate',
                  form.policyEffectiveDate
                )
              "
            ></masked-input>
            <span class="input__label">Policy Effective Date</span>
          </label>
          <b-icon pack="fas" icon="calendar" class="calendar-icon"></b-icon>
          <b-datepicker
            name="policyEffectiveDate1"
            @input="changedPolicyDate"
            v-model="selectedDate"
            :min-date="validationOptions.effectiveDateMin"
            :max-date="validationOptions.effectiveDateMax"
            :mobile-native="false"
          ></b-datepicker>
        </div>
        <label class="input -spacing-static-c" v-else>
          <input
            class="input__field"
            name="policyEffectiveDate"
            type="text"
            :value="getDateValue"
            disabled
          />
          <span class="input__label">Policy Effective Date</span>
        </label>
      </div>

      <p v-if="form.bodilyInjury">
        We have created the below package based on your Bodily Injury coverage.
        If you would like to make further adjustments, please call customer care
        at
        <a style="text-decoration:underline;" :href="'tel:1-' + $phoneNumber">{{
          $phoneNumber
        }}</a
        >.
      </p>

      <div class="-spacing-static-c">
        <label for="propertyDamage">Property Damage</label>
        <div class="input">
          <input
            class="input__field"
            name="propertyDamage"
            id="propertyDamage"
            type="text"
            v-model="form.propertyDamage"
            disabled
          />
        </div>
      </div>
    </div>

    <div
      class="column is-offset-1-desktop is-6-desktop"
      style="position: relative"
    >
      <div class="quote-header">
        <legend class="quote-legend">Your Quote</legend>
      </div>
      <div class="box box--bordered -spacing-static-c">
        <div
          v-if="quoteForm.vehicles.length > 1 && calculated"
          @click="$emit('previousVehicleClick')"
          :class="{
            'multi-vehicle-chevron__left': true,
            active: quoteForm.vehicles.length > 1 && coverageStepIndex !== 0,
            inactive: quoteForm.vehicles.length > 1 && coverageStepIndex === 0
          }"
        >
          <i class="fas fa-2x fa-chevron-left"></i>
        </div>
        <div
          v-if="quoteForm.vehicles.length > 1 && calculated"
          @click="$emit('nextVehicleClick')"
          :class="{
            'multi-vehicle-chevron__right': true,
            active: quoteForm.vehicles.length > 1 && coverageStepIndex === 0,
            inactive: quoteForm.vehicles.length > 1 && coverageStepIndex !== 0
          }"
        >
          <i class="fas fa-2x fa-chevron-right"></i>
        </div>
        <div>
          <h3
            v-if="quoteForm.vehicles.length > 1"
            class="heading right-section-first-container right-section-first-container--wpt"
          >
            Vehicle {{ coverageStepIndex + 1 }} of
            {{ quoteForm.vehicles.length }}
          </h3>
          <h3
            v-else
            class="heading right-section-first-container right-section-first-container--wpt"
          >
            Vehicle
          </h3>
          <div class="columns is-mobile">
            <div class="column is-4">Model:</div>
            <div class="column is-8">
              {{ currentVehicle }}
            </div>
          </div>
          <div
            v-if="
              quoteForm.vehicles[coverageStepIndex].vin &&
                !isThisSquish(quoteForm.vehicles[coverageStepIndex].vin)
            "
            class="columns is-mobile"
          >
            <div class="column is-4">VIN:</div>
            <div class="column is-8">
              {{ quoteForm.vehicles[coverageStepIndex].vin }}
            </div>
          </div>
        </div>
      </div>
      <CoveragePricing
        v-if="unlimitedState && !!quoteResponse"
        :estimatedMonthlyPayment="
          (
            roundAmountTo(getTotalMonthlyCost, 2) + getTotalMonthlyFees(false)
          ).toFixed(2)
        "
        :quoteResponse="quoteResponse"
        :isUnlimited="isUnlimited"
        :vehicleIndex="coverageStepIndex"
        :quoteForm="quoteForm"
        :quoteState="selectedState"
        :singlePaymentOption="
          roundAmountTo(
            singlePayPayment + getTotalMonthlyFees(true),
            2
          ).toFixed(2)
        "
        @toggleUnlimited="$emit('toggleUnlimited', coverageStepIndex)"
      />
      <div v-else class="box">
        <div class="columns is-mobile has-margin-top-1">
          <div class="column is-7">Base Charge:</div>
          <div class="column is-5">
            <span v-if="quoteResponse">${{ roundedBaseRate.toFixed(2) }}</span>
            <span v-else>-</span>&nbsp;per month
          </div>
        </div>

        <div class="columns is-mobile">
          <div class="column is-7">Per Mile Charge:</div>
          <div class="column is-5">
            <span v-if="quoteResponse">
              ${{
                quoteResponse.policies[0].vehicleInfo[
                  coverageStepIndex
                ].premiumInfo.perMileRate.toFixed(3)
              }}
            </span>
            <span v-else>-</span>&nbsp;per mile
          </div>
        </div>

        <div class="columns is-mobile">
          <div class="column is-7">Estimated monthly cost:</div>
          <div style="position: relative" class="column is-5">
            <span style="bottom: 0; position: absolute" v-if="quoteResponse">
              ${{
                isFloat(getMonthlyCostForIndividualVehicle(coverageStepIndex))
                  ? getMonthlyCostForIndividualVehicle(
                      coverageStepIndex
                    ).toFixed(2)
                  : getMonthlyCostForIndividualVehicle(coverageStepIndex)
              }}
            </span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="columns is-mobile">
          <div class="column is-12" v-if="quoteResponse">
            (Based on your estimated driving of
            <span>
              {{
                quoteResponse.policies[0].vehicleInfo[coverageStepIndex]
                  .premiumInfo.estMonthlyMiles
              }}
            </span>
            miles per month)
          </div>
        </div>
        <div>
          <h3 class="heading">
            Total Policy Premium
          </h3>
          <div class="columns is-mobile">
            <div class="column is-7">
              Estimated Monthly Payment (includes fees):
              <i class="icon icon--info tool-tip">
                <div class="content">
                  <p>
                    We are committed to providing you with great service and
                    100% transparent pricing. Your monthly payment includes a
                    Policy Fee of $5.00, a Mileage Monitoring Fee of $5.00 and a
                    Credit Card Fee of $4.95.
                  </p>
                  <i></i>
                </div>
              </i>
            </div>
            <div
              v-if="quoteResponse"
              class="column is-5"
              style="position:relative;"
            >
              <span style="position:absolute; bottom:0;">
                ${{
                  (
                    roundAmountTo(getTotalMonthlyCost, 2) +
                    getTotalMonthlyFees(false)
                  ).toFixed(2)
                }}
              </span>
            </div>
            <div v-else class="column is-4">-</div>
          </div>
        </div>
        <div>
          <h3 class="heading">
            Down Payment
          </h3>
          <div class="columns is-mobile">
            <div class="column is-7">
              Due Today:
            </div>
            <div v-if="quoteResponse" class="column is-5">
              ${{
                this.quoteResponse.policies[0].downPaymentMonthly.toFixed(2)
              }}
              <i class="icon icon--info tool-tip">
                <div class="content">
                  <p>
                    We are committed to providing you with great service and
                    100% transparent pricing. Your monthly payment includes a
                    Policy Fee of $5.00, a Mileage Monitoring Fee of $5.00 and a
                    Credit Card Fee of $4.95.
                  </p>
                  <i></i>
                </div>
              </i>
            </div>
            <div v-else class="column is-4">-</div>
          </div>
        </div>
      </div>
      <div>
        <p v-if="calculated">
          For your convenience, this quote has been sent to the email address
          you provided. You can access it anytime by clicking the link in the
          email, or via the "Retrieve your quote" window on the homepage.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable prettier/prettier */
import { mapGetters } from 'vuex';
import moment from 'moment';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import * as _ from 'lodash';
import { setTimeout } from "timers";
import CoveragePricing from "@/components/shared/CoveragePricing.vue";

export default {
  name: 'PennsylvaniaCoverages',
  components: {CoveragePricing},
  props: {
    calculated: {
      type: Boolean,
      required: true
    },
    coverageStepIndex: {
      type: Number,
      required: true
    },
    validationOptions: {
      type: Object,
      required: true
    },
    selectedState: {
      type: String,
      required: true
    },
    coverageForm: {
      type: Object,
      required: true
    },
    baseRateFromResponse: {
      type: String || null
    },
    isUnlimited: {
      type: Boolean
    },
singlePayPayment: {
      type: String
    },
    totalMonthlyCostRounded: {
      type: String || null
    },
    vehicleMonthlyCost: {
      type: String || null
    }
  },
  data: () => ({
    name: 'Your Coverage',
    form: {
      bodilyInjury: null,
      propertyDamage: null,
      comprehensiveDeductible: [],
      collisionDeductible: [],
      propertyDamageDeductible: [],
      uninsuredBodilyInjury: null,
      underinsuredMotorist: null,
      uninsuredCoverageType: null,
      uninsuredPropertyDamage: null,
      personalInjuryProtection: null,
      rentalReimbursement: [],
      tortOption: null,
      policyEffectiveDate: moment().format('MM/DD/YYYY')
    },
    selectedDate: null,
    oldDate: moment().format('MM/DD/YYYY')
  }),
  mounted() {
    this.form.uninsuredCoverageType = 'Stacked';
    this.sendUpdate('uninsuredCoverageType');
    if (!_.isEmpty(this.quoteForm.coverage)) {
      this.$validator
          .validate('policyEffectiveDate', this.form.policyEffectiveDate)
          .then(isValid => {
            if (!isValid) {
              setTimeout(() => {
                this.$el
                    .querySelector('[name="policyEffectiveDate"]')
                    .scrollIntoView();
              }, 100);
            }
          });

      if (
          !Array.isArray(this.quoteForm.vehicles) ||
          this.quoteForm.vehicles.length === 0
      ) {
        throw new Error(`Trying to select coverage with zero vehicles`);
      }

      this.coverageStepIndex = 0;

      if(!this.quoteForm.vehicles)
      {
        console.log("this.quoteForm.vehicles is missing");
      }

      if(!Array.isArray(this.quoteForm.vehicles))
      {
        console.log("this.quoteForm.vehicles is not an array");
      }

      if(!this.quoteForm.vehicles[this.coverageStepIndex])
      {
        console.log("this.quoteForm.vehicles has no element with index " + this.coverageStepIndex);
      }

      if (
          this.quoteForm.vehicles[this.coverageStepIndex].leaseOwnFinance
              .value === 'owned'
      ) {
        this.selectsCoverage[this.selectedState].comprehensiveDeductible.push(
            'I decline this coverage'
        );
        this.selectsCoverage[this.selectedState].collisionDeductible.push(
            'I decline this coverage'
        );
      }
    }
  },
  computed: {
    ...mapGetters([
      'quoteResponse',
      'quoteForm',
      'selectsAgencyCodes',
      'selectsCoverage',
      'selectsDrivers'
    ]),
    unlimitedState() {
      const unlimitedStates = ['AZ', 'GA', 'OH', 'OR', 'TN', 'TX'];
      return unlimitedStates.includes(this.selectedState);
    },
    compSelects() {
      const maxComp = Number.parseInt(this.quoteForm.vehicles[this.coverageStepIndex].statedValue.replace(/\$/g, '').replace(/,/g, ''));
      const originalSelects = this.selectsCoverage[this.selectedState].comprehensiveDeductible;

      let options = [];
      originalSelects.forEach(opt => {
        const numberOpt = Number.parseInt(opt.replace(/\$/g, '').replace(/,/g, ''));

        if (numberOpt <= maxComp) {
          options.push(opt);
        }
      })

      options.push('I decline this coverage');

      return options;
    },
    collSelects() {
      const maxComp = Number.parseInt(this.quoteForm.vehicles[this.coverageStepIndex].statedValue.replace(/\$/g, '').replace(/,/g, ''));
      const originalSelects = this.selectsCoverage[this.selectedState].collisionDeductible;

      let options = [];
      originalSelects.forEach(opt => {
        const numberOpt = Number.parseInt(opt.replace(/\$/g, '').replace(/,/g, ''));

        if (numberOpt <= maxComp) {
          options.push(opt);
        }
      })

      options.push('I decline this coverage');

      return options;
    },
    uninsuredMotoristStackingOptions() {
      return [
        'Stacked',
        'Unstacked'
      ];
    },
    currentVehicle() {
      if (
          this.quoteForm &&
          this.quoteForm.vehicles &&
          (!this.quoteForm.vehicles[this.coverageStepIndex] || !this.quoteForm.vehicles[this.coverageStepIndex].year)
      ) {
        return null;
      }
      const vehicleYear = this.quoteForm.vehicles[this.coverageStepIndex].year || '';
      const vehicleMake = this.quoteForm.vehicles[this.coverageStepIndex].make || '';
      const vehicleModel = this.quoteForm.vehicles[this.coverageStepIndex].model || '';
      const vehicleStyle = this.quoteForm.vehicles[this.coverageStepIndex].bodyStyle || '';
      return vehicleYear +
          ' ' +
          vehicleMake +
          ' ' +
          vehicleModel +
          ' ' +
          vehicleStyle;
    },
    autoCorrectedDatePipe() {
      return createAutoCorrectedDatePipe('mm/dd/yyyy');
    },
    coverageFormWatch() {
      return _.cloneDeep(this.coverageForm);
    },
    getDateValue() {
      if (this.form.policyEffectiveDate) {
        return this.form.policyEffectiveDate;
      }
    },
    getTotalMonthlyCost() {
      if (this.quoteResponse && this.quoteResponse.policies[0].vehicleInfo) {
        let totalMonthlyCost = 0;
        let that = this;
        this.quoteResponse.policies[0].vehicleInfo.forEach(function(
            vehicle,
            index
        ) {
          totalMonthlyCost += that.getMonthlyCostForIndividualVehicle(index);
        });
        return totalMonthlyCost;
      }
    },
    roundedBaseRate() {
      let baseRateFromResponse = 0.0;
      if (this.quoteResponse) {
        baseRateFromResponse = this.quoteResponse.policies[0].vehicleInfo[
            this.coverageStepIndex
            ].premiumInfo.baseRate.toFixed(2);
      }
      return this.roundAmountTo(baseRateFromResponse, 2);
    },
    uninsuredBodilyInjuryOptions() {
      const selectedIndex = this.selectsCoverage[
          this.selectedState
          ].bodilyInjury.indexOf(this.form.bodilyInjury);
      let options = _.cloneDeep(
          this.selectsCoverage[this.selectedState].uninsuredBodilyInjury
      );
      if (selectedIndex !== null) {
        options = options.slice(0, selectedIndex + 1);
      }
      if (
          options[options.length - 1] &&
          options[options.length - 1].toLowerCase() === 'i decline this coverage'
      ) {
        return options;
      }
      if (options[options.length - 1] !== 'I decline this coverage') {
        options.push('I decline this coverage');
      }
      return options;
    },
    underinsuredMotoristOptions() {
      const selectedIndex = this.selectsCoverage[
          this.selectedState
          ].bodilyInjury.indexOf(this.form.bodilyInjury);
      let options = _.cloneDeep(
          this.selectsCoverage[this.selectedState].underinsuredMotorist
      );
      if (selectedIndex !== null) {
        options = options.slice(0, selectedIndex + 1);
      }
      if (
          options[options.length - 1] &&
          options[options.length - 1].toLowerCase() === 'i decline this coverage'
      ) {
        return options;
      }
      if (options[options.length - 1] !== 'I decline this coverage') {
        options.push('I decline this coverage');
      }
      return options;
    }
  },
  methods: {
    isThisSquish(vin) {
      const regex = RegExp('/*0000000');
      const validVinRegex = RegExp('/[ioq]+', 'gi');

      return !!(
          regex.test(vin) ||
          vin.length !== 17 ||
          vin.includes('*') ||
          vin.includes('!') ||
          validVinRegex.test(vin)
      );
    },
    sendUpdate(field) {
      if (Array.isArray(this.form[field])) {
        this.$emit(
            'updateField',
            field,
            this.coverageStepIndex,
            this.form[field][this.coverageStepIndex]
        )
      } else {
        this.$emit(
            'updateField',
            field,
            this.coverageStepIndex,
            this.form[field]
        )
      }
      if (
          (field === 'accidentalDeath' ||
              field === 'funeralBenefits' ||
              field === 'incomeLoss') &&
          this.form[field] !== 'I decline this coverage'
      ) {
        this.form.combinedFirstParty = 'I decline this coverage';
      }
    },
    dateInputChanged(event, key, value) {
      let validator = this.$validator;
      validator.validate(key, value);
      this.$emit(
          'updateField',
          'policyEffectiveDate',
          this.coverageStepIndex,
          this.form.policyEffectiveDate
      )
      setTimeout(() => {
        if (
            this.errors.count() === 0 &&
            this.quoteResponse &&
            this.oldDate !== event
        ) {
          this.$emit('updateQuoteResponseToNull');
          this.oldDate = event;
        }
      }, 50);
    },
    changedPolicyDate(event) {
      if (this.quoteResponse) {
        this.updateQuoteResponseToNull();
      }
      this.form.policyEffectiveDate = moment(event).format('MM/DD/YYYY');
      this.selectedDate = null;
      this.oldDate = this.form.policyEffectiveDate;
      this.$el.querySelector('[name="policyEffectiveDate"]').focus();
      this.$validator.validate(
          'policyEffectiveDate',
          this.form.policyEffectiveDate
      );
      this.sendUpdate('policyEffectiveDate');
    },
    getMonthlyCostForIndividualVehicle(itemIndex) {
      if (this.quoteResponse && this.quoteResponse.policies[0].vehicleInfo) {
        let vehicle = this.quoteResponse.policies[0].vehicleInfo[itemIndex];
        return this.roundAmountTo(vehicle.premiumInfo.estMonthlyNoFee, 2);
      }
    },
    isFloat(value) {
      if (value) {
        return Number(value) === value && value % 1 !== 0;
      }
    },
    roundAmountTo(number, digits) {
      if (digits === undefined) {
        digits = 0;
      }
      var multiplier = Math.pow(10, digits);
      number = parseFloat((number * multiplier).toFixed(11));
      return Math.round(number) / multiplier;
    },
    getTotalMonthlyFees(isSixMonth) {
      let totalMonthlyFees = 13;
      if (isSixMonth) {
        totalMonthlyFees = 33;
      }
      return totalMonthlyFees;
    }
  },
  watch: {
    coverageFormWatch: {
      immediate: true,
      handler: function(newValue, oldValue) {
        if (newValue && oldValue && !_.isEqual(newValue, oldValue)) {
          this.form = _.cloneDeep(this.coverageForm);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.active {
  color: $primary;
}
.inactive {
  color: lightgrey;
}
.disabled {
  background-color: #b5b4ba;
}
.disabled__button__color {
  color: #ffffff !important;
}
button {
  border: none;
}
.box {
  padding: 1.5rem;

  @media (min-width: 1000px) {
    padding: 2rem;
  }

  @media (min-width: 1400px) {
    padding: 1rem 3rem;
    padding-bottom: 3.5rem;
  }
}
.total-cost-container {
  @media (min-width: 1000px) {
    margin-top: 1.5rem;
  }
}

.heading,
.estimated-cost {
  font-family: $family-sans-serif-bold;
  text-transform: none;
  letter-spacing: 0;
  font-size: inherit;
}

.heading {
  margin-bottom: 1rem;

  &:last-of-type {
    border-top: 1px solid $mischka;
    margin-top: 2rem;
    padding-top: 2rem;
  }
}

.right-section-first-container {
  border-top: none !important;
  margin-top: 0 !important;
}

.note {
  color: $mischka;
}

.input__field {
  min-height: 3.7rem;
}

.input__field:disabled {
  color: #737278;
}

.effective-date-field {
  margin-top: 1.75rem;
  @media (max-width: 480px) {
    margin-top: 1rem;
  }
}

@media (max-width: 760px) {
  .quote-wizard .button-primary + .button-primary.third-button {
    margin-top: 1rem;
    margin-left: 0;
  }
}
.tool-tip {
  color: #737278;
  top: 2px;
  left: 2px;
  .content {
    @media (min-width: 992px) {
      width: 420px;
    }
    @media (max-width: 991px) {
      width: 415px;
      left: 8px;
      i {
        left: 50%;
      }
    }
    @media (min-width: 992px) {
      left: 50%;
    }
    @media (max-width: 760px) {
      width: 300px;
      left: -15px;
      i {
        left: 57%;
      }
    }
  }
}
.multi-vehicle-chevron {
  display: flex;

  &__right {
    position: absolute;
    top: 200px;
    right: 12px;

    @media (min-width: 1000px) {
      right: 15px;
    }

    @media (min-width: 1400px) {
    }
  }
  &__left {
    position: absolute;
    top: 200px;
    left: 12px;

    @media (min-width: 1000px) {
      left: 15px;
    }

    @media (min-width: 1400px) {
    }
  }
}
.button-container {
  .button-left-align {
    display: flex;
    margin-top: 2rem;
    justify-content: flex-start;
  }

  .button-right-align {
    display: flex;
    margin-top: 2rem;
    justify-content: flex-end;
  }
}
</style>